export default {
  public: {
    more: 'more'
  },
  route: {
    home: 'HOME',
    about: 'ABOUT',
    product: 'PRODUCT',
    news: 'NEWS',
    contact: 'CONTACT'
  },
  Industry: {
    name: 'Business range',
    desc: 'Alcohols, aldehydes, acids, organic amines, organic silicon, chemical additives and other fields......',
    title_1: 'Surfactant Industry',
    title_2: 'Textile Industry',
    title_3: 'Plastic Industry',
    title_4: 'Pharmaceutical & Pesticide',
    title_5: 'Electronics Related Industry'
  },

  homeNews: {
    CompanyNews: 'Company news',
    PolicyInfo: 'Policy information'
  },

  news: {
    title: 'News Info'
  },
  prod: {
    name: 'Products Info',
    attr_1: 'Surfactant Industry',
    attr_2: 'Textile Industry',
    attr_3: 'Plastic Industry',
    attr_4: 'Pharmaceutical & Pesticide',
    attr_5: 'Electronics Related Industry',
  },
  abouts: {
    title: 'About Us',
    sub_title: 'Company profile',
    content_1: 'Jinhui (Nanjing) International Trade Co., LTD., founded on February 02, 2021. The company is located in Nanjing, the ancient capital of six dynasties in China. The office and residence are located near zhushan Road station of Metro Line 1 and Line 5. It is very convenient to reach Nanjing South High-speed Railway station and Nanjing Lukou Airport.',
    content_2: "The company's main chemical products sales, import and export business, products are used in many industrial fields. All the managers of the company have the education background of chemistry and international trade. They have been engaged in related work for more than ten years and have rich professional quality and operation experience.",
    content_3: "Companies adhering to: 'integrity-based, benefit to justice' business philosophy, layout of the company's development; The company is willing to share profits to the greatest extent, reserve talents and establish a diversified business model.Surfactant industry: n-butanol, n-hexanol, isomeric 10 alcohol, isomeric 13 alcohol, amino silicone oil, etc"
  },
  contact: {
    title: 'Contact Us',
    address: 'Room 606,B1 Building,29 Kejian Road,Jiangning Zone,Nanjing Jiangsu,China',
    people: 'Mr Zhou'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js